class ContentTabs {

  constructor(block) {
    this.block = block
    this.init()
  }

  init() {
    this.block.querySelector('.content-tabs__nav').addEventListener('click', (ev) => {
      if (ev.target.classList.contains('active') || !ev.target.classList.contains('content-tabs__nav-item')) return
      const target = ev.target.getAttribute('data-target')
      const content_block = this.block.querySelector(`.content-tabs__content-container [data-slug="${target}"]`)
      const active_content = this.block.querySelector('.content-tabs__content-container .active')
      const active_tab = this.block.querySelector('.content-tabs__nav .active')
      if (active_content) {
        active_content.classList.remove('active')
      }
      if (active_tab) {
        active_tab.classList.remove('active')
      }
      ev.target.classList.add('active')
      content_block.classList.add('active')

    })
  }

}

export default ContentTabs